import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import store from '@/store/store';
import { UPDATE_CURRENT_USER_INFO } from '@/store/common';
import { currentUserInfo as api } from '@/common/api/brief';

/**
 * 获取当前用户信息
 * @description
 * @return {*}
 * @demo
  const {
    getCurrentUserInfo,
    currentUserInfo,
  } = useCurrentUserInfo();
 */
export const useCurrentUserInfo = ({ immediate }: {
  /** 是否立即调用接口获取一次 */
  immediate: boolean;
} = { immediate: true }) => {

  /** 获取当前用户信息 */
  const currentUserInfo = useSelector((state: any) => state.common.currentUserInfo) || null;

  /** 更新当前用户信息 */
  const updateCurrentUserInfo = useCallback((data) => {
    store.dispatch(UPDATE_CURRENT_USER_INFO(data));
  }, []);

  /** 获取当前用户信息
   * @description
   * @param {*} force 强制更新数据
   * @return {*}
   * @demo
   */
  const getCurrentUserInfo = useCallback(async (force?: boolean): Promise<any> => {
    // 如果已经有缓存，直接返回
    if (currentUserInfo && Object.keys(currentUserInfo).length && !force) {
      return currentUserInfo;
    }

    try {
      const res = await api().catch(() => {});
      const currentUserInfo = res || {};

      // 更新当前用户信息
      updateCurrentUserInfo(currentUserInfo);
      return currentUserInfo;
    } catch (error) {
      console.error('获取当前用户信息失败:', error);
      throw error;
    }
  }, [currentUserInfo, updateCurrentUserInfo]);

  useEffect(() => {
    immediate && getCurrentUserInfo();
  }, []);

  return {
    // actions
    /** 获取当前用户信息 */
    getCurrentUserInfo,

    // state
    /** 当前用户信息 */
    currentUserInfo,
  };
};
